<template>
  <div>
    <v-dialog v-model="dialogShow" persistent width="1600" class="dialog myScrollArea">

      <v-card>
        <v-card-title class="dialogTitle">
          <p class="dialogTitle-title">添加素材</p>
          <v-spacer></v-spacer>
          <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text style="overflow:auto;" class="myScrollArea">
          <div style="width:100%;height:690px;margin-top:20px;display:flex;">
            <div style="width:440px;height:100%;">

              <!--数据-->
              <div style="width:100%;height:440px;box-shadow:0px 2px 7px rgba(166, 166, 166, 0.25);">
                <!--顶部切换-->
                <div style="width:100%;height:70px;border-bottom:1px solid #E5E5E5;padding:20px 25px 0 20px;display:flex;">
                  <div @click="dataAreaTab = '我的数据'" class="dataAreaTab">
                    <p :style="{'color':dataAreaTab === '我的数据' ? '#000000' : '#A7A7A7','font-weight':dataAreaTab === '我的数据' ? 'bold' : ''}"
                       class="dataAreaTab_text">我的数据</p>
                    <div :style="{'display':dataAreaTab === '我的数据' ? 'block' : 'none'}" class="dataAreaTab_line"></div>
                  </div>
                  <div @click="dataAreaTab = '我的收藏'" style="margin-left:22px;" class="dataAreaTab">
                    <p :style="{'color':dataAreaTab === '我的收藏' ? '#000000' : '#A7A7A7','font-weight':dataAreaTab === '我的收藏' ? 'bold' : ''}"
                       class="dataAreaTab_text">我的收藏</p>
                    <div :style="{'display':dataAreaTab === '我的收藏' ? 'block' : 'none'}" class="dataAreaTab_line"></div>
                  </div>
                  <v-spacer></v-spacer>

                  <v-btn @click="" dark height="32" depressed color="#1976D2">
                    <p style="font-size:16px;"><span style="margin-right:8px;" class="iconfontFamily">&#xe6a4;</span>素材库</p>
                  </v-btn>

                </div>

                <!--我的数据-->
                <div v-show="dataAreaTab === '我的数据'" style="width:100%;height: calc(100% - 70px);display:flex;flex-direction: column;">
                  <!--数据类型列表-->
                  <div v-if="currDataAreaType === 'none'" style="width:100%;height:calc(100% - 70px - 1px);padding:15px;">
                    <div v-for="(item,index) in dataAreaTypeList" :key="'dataAreaType'+index" class="dataAreaType">
                      <img :src="item.thumb" style="width:45px;height:45px;">
                      <p style="margin-left:20px;color:#000000;font-size:16px;">{{item.text}}</p>
                      <v-spacer></v-spacer>
                      <p @click="chooseDataAreaType(item)" class="dataAreaType_btn iconfontFamily">&#xe6ad;</p>
                    </div>
                  </div>

                  <!--返回行-->
                  <div v-if="currDataAreaType !== 'none'" style="padding:20px 25px;display:flex;">
                    <p @click="backToDataAreaTypeNone" style="line-height:24px;font-size:16px;color:#2A82E4;cursor:pointer;"><span class="iconfontFamily">&#xe6a8;</span>返回</p>
                    <v-spacer></v-spacer>
                    <p style="line-height:24px;font-size:16px;color:#A6A6A6;">当前：{{currDataAreaType === 'folder' ? '我的文件' : currDataAreaType === 'image' ? '图片素材' : '视频素材'}}</p>
                  </div>

                  <!--我的文件列表-->
                  <div v-if="currDataAreaType === 'folder'" ref="myFolderListArea"
                       style="width:100%;flex:1;padding:0 25px 20px 25px;overflow:auto;" class="myScrollArea_light">

                    <v-text-field v-model="myFolderSearchKeyword" @keyup.enter.native="getMyFolderList(1)"
                                  autocomplete="off" dense outlined placeholder="在我的文件中搜索" hide-details>
                      <template v-slot:append>
                        <p @click="getMyFolderList(1)" style="font-size:16px;font-weight:bold;color:#000000;cursor:pointer;" class="iconfontFamily mt-1">&#xe630;</p>
                      </template>
                    </v-text-field>

                    <!--列表-->
                    <div @click="chooseMyFolderItem(item)" v-for="(item,index) in myFolderList" :key="'myFolderItem'+index"
                         :style="{'border':currMyFolderId === item.fileId ? '1px solid #1976D2' : '1px solid #E5E5E5'}"
                         style="width:100%;height:84px;border-radius:5px;padding:14px;margin-top:15px;cursor:pointer;">
                      <p style="width:100%;color:#000000;font-size:16px;line-height:22px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{item.fileName}}</p>

                      <!--个人文件-->
                      <div v-if="item.authority === 0" style="margin-top:14px;display:flex;align-items:center;font-size:14px;">
                        <p style="color:#000000;">
                        <span :style="{'color':item.labelCount<=2000 ? '#00C951' : item.labelCount<=10000 ? '#FF8D1A' : '#FF0000'}"
                              style="margin-right:12px;" class="iconfontFamily">&#xe6b0;</span>
                          对象数量：{{item.labelCount}}
                        </p>
                      </div>

                      <!--团队文件-->
                      <div v-if="item.authority === 1" style="margin-top:14px;display:flex;align-items:center;font-size:14px;">
                        <div style="width:38px;height:22px;background:#007A6C;border-radius:2px;color:#ffffff;text-align:center;">团队</div>
                        <div style="position:relative;height:22px;margin-left:16px;">
                          <img v-for="(itemAvatar,indexAvatar) in item.teamList" :key="'itemAvatar'+indexAvatar" :src="itemAvatar"
                               :style="{'left':indexAvatar * 19 + 'px','z-index':5-indexAvatar}"
                               style="position:absolute;top:0;width:22px;height:22px;border-radius:50%;">
                        </div>
                      </div>

                    </div>
                  </div>

                  <!--图片素材列表-->
                  <div v-if="currDataAreaType === 'image'" ref="myImageListArea"
                       style="width:100%;flex:1;padding:0 25px 20px 25px;overflow:auto;" class="myScrollArea_light">
                    <v-text-field v-model="myImageSearchKeyword" @keyup.enter.native="getMyImageList(1)"
                                  autocomplete="off" dense outlined placeholder="在图片素材中搜索" hide-details>
                      <template v-slot:append>
                        <p @click="getMyImageList(1)" style="font-size:16px;font-weight:bold;color:#000000;cursor:pointer;" class="iconfontFamily mt-1">&#xe630;</p>
                      </template>
                    </v-text-field>

                    <!--列表-->
                    <div @click="chooseMyImageItem(item)" v-for="(item,index) in myImageList" :key="'myImageItem'+index"
                         :style="{'border':currMyImageId === item.materialId ? '1px solid #1976D2' : '1px solid #E5E5E5'}"
                         style="width:100%;height:84px;border-radius:5px;padding:12px 24px 12px 14px;margin-top:15px;display:flex;align-items:center;cursor:pointer;">

                      <img :src="item.thumbUrl" style="width:60px;height:60px;">
                      <div style="margin:0 14px;flex:1;overflow:hidden;">
                        <p style="line-height:22px;font-size:16px;color:#000000;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.fileName}}</p>
                        <p style="line-height:20px;margin-top:14px;font-size:14px;color:#808080;">大小：{{$utils.sizeToStr(item.fileSize)}}</p>
                      </div>

                      <v-tooltip top max-width="150" color="rgba(229, 229, 229, 0.75)">
                        <template v-slot:activator="{ on, attrs }">
                          <p @click.stop="addImageToMap(index)" v-bind="attrs" v-on="on" style="margin-right:25px;" class="myImageItemBtn iconfontFamily">&#xe6a6;</p>
                        </template>
                        <span style="font-size:16px;color:#000000;">导入至地图显示</span>
                      </v-tooltip>
                      <v-tooltip top max-width="80" color="rgba(229, 229, 229, 0.75)">
                        <template v-slot:activator="{ on, attrs }">
                          <p @click.stop="deleteImageItem(index)" v-bind="attrs" v-on="on" class="myImageItemBtn iconfontFamily">&#xe696;</p>
                        </template>
                        <span style="font-size:16px;color:#000000;">删除</span>
                      </v-tooltip>
                    </div>
                  </div>




                </div>

              </div>
              <!--上传数据-->
              <div style="width:100%;height:calc(100% - 440px - 20px);margin-top:20px;box-shadow:0px 2px 7px rgba(166, 166, 166, 0.25);padding:20px;">
                <p style="font-size:18px;font-weight:bold;color:#000000;">上传数据</p>
                <div @drop="materialUploadDrop" style="position:relative;width:calc(100% - 10px);height:135px;border:1px dashed #e5e5e5;margin:15px auto 0 auto;">
                  <div style="width:100%;height:100%;display:flex;flex-direction: column;align-items: center;">
                    <p style="margin-top:23px;line-height:33px;font-size:48px;color:#e5e5e5;" class="iconfontFamily">&#xe6a9;</p>
                    <p style="margin-top:18px;font-size:16px;color:#000000;">
                      <span style="color:#1976D2;">点击上传</span>
                      按钮或将您的文件拖放到此处
                    </p>
                    <p style="margin-top:5px;font-size:12px;color:#888888;">.jpg/.jpeg/.png</p>
                  </div>
                  <input ref="addMaterialUploadImageInput" @change="addMaterialUploadImage()" type="file" accept="image/jpeg,image/jpg,image/png"
                         style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;">
                </div>
              </div>

            </div>
            <!--数据展示区域-->
            <div style="flex:1;height:100%;margin-left:20px;box-shadow:0px 2px 7px rgba(166, 166, 166, 0.25);">

              <!--文件数据-->
              <div v-if="currShowData === 'folder' && currMyFolderId !== ''" style="width:100%;height:100%;display:flex;">

                <!--数据列表-->
                <div style="width:360px;height:100%;padding:26px 0 20px 0;margin-right:12px;display:flex;flex-direction: column;">
                  <p style="margin-left:27px;color:#808080;font-size:16px;">选择要导入的对象</p>

                  <div v-if="folderDataInit" id="addSceneMaterialFolderDataTree" class="markerFolderDataTree myScrollArea_light">
                    <v-treeview v-model="chooseFolderDataList"
                                open-all return-object selectable selected-color="#2A82E4"
                                :items="folderDataList" dense style="font-size:14px;">
                      <!--名称前图标-->
                      <template v-slot:prepend="{ item, open }">
                        <!--文件夹 class prependIconFolder作为标识-->
                        <p v-if="item.type === 'folder'" style="margin-left:5px;color:#69AFFF;font-size:16px;" class="prependIconFolder iconfontFamily">&#xe64d;</p>
                        <!--根目录 名称前图标-->
                        <p v-else-if="item.type === 'root'" style="margin-left:5px;"></p>
                        <!--普通标记-->
                        <p v-else style="margin-left:5px;color:#a6a6a6;font-size:16px;" class="iconfontFamily" v-html="$utils.getPrependIconByType(item.type)"></p>
                      </template>

                      <!--标识/文件夹 名称-->
                      <template v-slot:label="{ item, open }">
                        <p @click="clickTreeItemName(item)"
                           :style="{'font-weight':item.type ==='root'?'bold':'normal',
                         'cursor':item.type !=='root'&&item.type !=='folder' ? 'pointer' : ''}"
                           style="margin-top: 2px;">{{item.name}}</p>
                      </template>

                    </v-treeview>


                  </div>

                  <div v-show="folderDataList.length > 0" style="margin-top:20px;">
                    <v-btn @click="addMaterialFromFolderOK" dark width="100" height="35" depressed color="#1976D2" style="float:right;">
                      <p style="font-size:16px;">导入素材</p>
                    </v-btn>
                  </div>

                </div>
                <!--地图-->
                <div style="flex:1;height:100%;">
                  <div id="addSceneMaterialMap" style="width:100%;height:100%;background:#000000;"></div>
                </div>
              </div>


              <!--图片素材-->
              <div v-if="currShowData === 'image' && currMyImageId !== ''" style=";width:100%;height:100%;">
                <one-picture-previewer :pictureUrl="currMyImageItem.fileUrl"></one-picture-previewer>
              </div>




              <!--没有数据-->
              <p v-if="currShowData === 'none' || (currShowData === 'folder' && currMyFolderId === '')
            || (currShowData === 'image' && currMyImageId === '')"
                 style="margin:330px auto 0 auto;text-align:center;color:#A6A6A6;font-size:20px;">请选择要预览的数据文件</p>

            </div>






          </div>





        </v-card-text>


      </v-card>


    </v-dialog>


    <!--删除图片素材-->
    <v-dialog v-model="deleteImageDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="deleteImageDialogShow = false;" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text style="padding:80px 80px 44px 90px">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">素材删除后将无法恢复<br/>确定删除？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="deleteImageDialogShow = false;" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="deleteImageDialogOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>




</template>

<script>
import mapboxgl from "mapbox-gl";
import * as turf from "@turf/turf";


import marker_one_red1 from '@/assets/mapbox/marker_image/marker_one/marker_one_red1.png'
import marker_one_blue1 from '@/assets/mapbox/marker_image/marker_one/marker_one_blue1.png'
import marker_one_yellow1 from '@/assets/mapbox/marker_image/marker_one/marker_one_yellow1.png'
import marker_one_green1 from '@/assets/mapbox/marker_image/marker_one/marker_one_green1.png'
import marker_one_cyan1 from '@/assets/mapbox/marker_image/marker_one/marker_one_cyan1.png'

import marker_two_red1 from '@/assets/mapbox/marker_image/marker_two/marker_two_red1.png'
import marker_two_blue1 from '@/assets/mapbox/marker_image/marker_two/marker_two_blue1.png'
import marker_two_yellow1 from '@/assets/mapbox/marker_image/marker_two/marker_two_yellow1.png'
import marker_two_green1 from '@/assets/mapbox/marker_image/marker_two/marker_two_green1.png'
import marker_two_cyan1 from '@/assets/mapbox/marker_image/marker_two/marker_two_cyan1.png'

import marker_three_red1 from '@/assets/mapbox/marker_image/marker_three/marker_three_red1.png'
import marker_three_blue1 from '@/assets/mapbox/marker_image/marker_three/marker_three_blue1.png'
import marker_three_yellow1 from '@/assets/mapbox/marker_image/marker_three/marker_three_yellow1.png'
import marker_three_green1 from '@/assets/mapbox/marker_image/marker_three/marker_three_green1.png'
import marker_three_cyan1 from '@/assets/mapbox/marker_image/marker_three/marker_three_cyan1.png'

import marker_four_red1 from '@/assets/mapbox/marker_image/marker_four/marker_four_red1.png'
import marker_four_blue1 from '@/assets/mapbox/marker_image/marker_four/marker_four_blue1.png'
import marker_four_yellow1 from '@/assets/mapbox/marker_image/marker_four/marker_four_yellow1.png'
import marker_four_green1 from '@/assets/mapbox/marker_image/marker_four/marker_four_green1.png'
import marker_four_cyan1 from '@/assets/mapbox/marker_image/marker_four/marker_four_cyan1.png'

import marker_five_red1 from '@/assets/mapbox/marker_image/marker_five/marker_five_red1.png'
import marker_five_blue1 from '@/assets/mapbox/marker_image/marker_five/marker_five_blue1.png'
import marker_five_yellow1 from '@/assets/mapbox/marker_image/marker_five/marker_five_yellow1.png'
import marker_five_green1 from '@/assets/mapbox/marker_image/marker_five/marker_five_green1.png'
import marker_five_cyan1 from '@/assets/mapbox/marker_image/marker_five/marker_five_cyan1.png'

import marker_six_red1 from '@/assets/mapbox/marker_image/marker_six/marker_six_red1.png'
import marker_six_blue1 from '@/assets/mapbox/marker_image/marker_six/marker_six_blue1.png'
import marker_six_yellow1 from '@/assets/mapbox/marker_image/marker_six/marker_six_yellow1.png'
import marker_six_green1 from '@/assets/mapbox/marker_image/marker_six/marker_six_green1.png'
import marker_six_cyan1 from '@/assets/mapbox/marker_image/marker_six/marker_six_cyan1.png'

import marker_seven_red1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_red1.png'
import marker_seven_blue1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_blue1.png'
import marker_seven_yellow1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_yellow1.png'
import marker_seven_green1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_green1.png'
import marker_seven_cyan1 from '@/assets/mapbox/marker_image/marker_seven/marker_seven_cyan1.png'

import marker_eight_red1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_red1.png'
import marker_eight_blue1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_blue1.png'
import marker_eight_yellow1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_yellow1.png'
import marker_eight_green1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_green1.png'
import marker_eight_cyan1 from '@/assets/mapbox/marker_image/marker_eight/marker_eight_cyan1.png'
import OnePicturePreviewer from "@/components/one_picture_previewer/OnePicturePreviewer";
import marker_nine_red1 from "@/assets/mapbox/marker_image/marker_nine/marker_nine_red1.png";
import marker_nine_blue1 from "@/assets/mapbox/marker_image/marker_nine/marker_nine_blue1.png";
import marker_nine_yellow1 from "@/assets/mapbox/marker_image/marker_nine/marker_nine_yellow1.png";
import marker_nine_green1 from "@/assets/mapbox/marker_image/marker_nine/marker_nine_green1.png";
import marker_nine_cyan1 from "@/assets/mapbox/marker_image/marker_nine/marker_nine_cyan1.png";

export default {
  name: "AddSceneMaterial",
  components:{OnePicturePreviewer},
  props:["dialogShow"],
  data(){
    return{
      addSceneMaterialMap: "",
      addSceneMaterialMapInitFinish:false,


      dataAreaTab:"我的数据",
      dataAreaTypeList:[
        {
          text:"我的文件",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310241059000041566.png",
          nextPage:"folder"
        },
        {
          text:"图片素材",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/20231024105900057237.png",
          nextPage:"image"
        },
        {
          text:"视频素材",
          thumb:"https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/202310241100000081123.png",
          nextPage:"video"
        }
      ],

      currDataAreaType:"none",  //左侧选中的类型：：none无，folder标记文件，image图片


      currShowData:"none",   //右侧展示数据类型：none无，folder标记文件，image图片


      //我的文件
      myFolderSearchKeyword:"",
      myFolderList:[],
      myFolderListCurrPageNum:1,
      myFolderListTotalPageNum:0,

      currMyFolderId:"",

      //当前选中的我的文件
      folderDataInit:false,
      folderDataList:[],    //解析后的数据
      chooseFolderDataList:[],    //选中的数据
      deepFirstTraversalList:[],    //深度遍历的数据
      //文件地图标记数据
      mapLayerData:{
        //点集合
        pointList:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线集合
        lineList:{
          line:{
            "type": "FeatureCollection",
            "features": []
          },
          lineName:{
            'type': 'FeatureCollection',
            'features': []
          }
        },
        //多边形集合
        polygonList:{
          polygon:{
            "type": "FeatureCollection",
            "features": []
          },
          polygonName:{
            'type': 'FeatureCollection',
            'features': []
          }
        },


      },



      //图片素材
      myImageSearchKeyword:"",
      myImageList:[],
      myImageListCurrPageNum:1,
      myImageListTotalPageNum:0,

      currMyImageItem:"",
      currMyImageId:"",

      //删除图片提示弹窗
      deleteImageDialogShow:false,
      deleteImageIndex:"",


    }


  },
  watch:{
    chooseFolderDataList(){
      console.log(this.chooseFolderDataList)
    },
    //切换我的数据和我的收藏
    dataAreaTab(){
      if(this.dataAreaTab === "我的收藏"){
        this.backToDataAreaTypeNone();
      }

    }
  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },


    //选择某类我的数据
    chooseDataAreaType(item){
      this.currDataAreaType = item.nextPage;

      //跳转后处理
      switch(item.nextPage){
        case "folder":{
          this.myFolderList = []
          this.getMyFolderList(1);

          setTimeout(()=>{
            this.$refs.myFolderListArea.addEventListener("scroll",this.myFolderListAreaScrollFun)
          },200)


          break;
        }
        case "image":{
          this.myImageList = []
          this.getMyImageList(1);

          setTimeout(()=>{
            this.$refs.myImageListArea.addEventListener("scroll",this.myImageListAreaScrollFun)
          },200)


          break;
        }


      }

    },
    //数据列表滚动到底方法
    myFolderListAreaScrollFun(){
      let viewH = this.$refs.myFolderListArea.clientHeight;   //视野高度
      let contentH = this.$refs.myFolderListArea.scrollHeight;   //内容高度
      let scrollTop =this.$refs.myFolderListArea.scrollTop;
      if(scrollTop >= contentH -viewH){
        console.log("滚动到底")
        if(this.myFolderListCurrPageNum < this.myFolderListTotalPageNum){
          this.getMyFolderList(this.myFolderListCurrPageNum+1);
        }
      }
    },
    myImageListAreaScrollFun(){
      let viewH = this.$refs.myImageListArea.clientHeight;   //视野高度
      let contentH = this.$refs.myImageListArea.scrollHeight;   //内容高度
      let scrollTop =this.$refs.myImageListArea.scrollTop;
      if(scrollTop >= contentH -viewH){
        console.log("滚动到底")
        if(this.myImageListCurrPageNum < this.myImageListTotalPageNum){
          this.getMyImageList(this.myImageListCurrPageNum+1);
        }
      }
    },


    //从某类我的数据返回
    backToDataAreaTypeNone(){
      switch(this.currDataAreaType){
        case "folder":{
          //我的文件
          this.myFolderSearchKeyword = "";
          this.myFolderList = [];
          this.currMyFolderId = "";

          //当前选中的我的文件
          this.folderDataInit = false;
          this.folderDataList = [];    //解析后的数据
          this.chooseFolderDataList = [];    //选中的数据
          this.deepFirstTraversalList = [];    //深度遍历的数据
          //文件地图标记数据
          this.clearMaterialMapLayer();

          this.$refs.myFolderListArea.removeEventListener("scroll",this.myFolderListAreaScrollFun)

          break;
        }
        case "image":{
          this.myImageSearchKeyword = "";
          this.myImageList = [];
          this.currMyImageId = "";

          this.$refs.myImageListArea.removeEventListener("scroll",this.myImageListAreaScrollFun)

          break;
        }
        case "video":{

          break;
        }
      }

      this.currDataAreaType = 'none';
      this.currShowData = 'none';  //右侧展示数据类型：none无，folder标记文件，image图片

    },


    //文件//////////////////////////////////////////////////////////////////////////////////////////
    //获取我的文件列表
    getMyFolderList(pageNum){
      this.currMyFolderId = "";

      //当前选中的我的文件
      this.folderDataInit = false;
      this.folderDataList = [];    //解析后的数据
      this.chooseFolderDataList = [];    //选中的数据
      this.deepFirstTraversalList = [];    //深度遍历的数据
      //文件地图标记数据
      this.clearMaterialMapLayer();


      this.$axios({
        method:"get",
        url:"/authorApi/z-geo-file/getFileListWithTeam",
        params:{
          keyWord:this.myFolderSearchKeyword,
          curPageNum:pageNum,
          maxResultNum:10,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          if(pageNum === 1){
            this.myFolderList = resultData.data.list;
          }
          else{
            this.myFolderList = this.myFolderList.concat(resultData.data.list);
          }
          this.myFolderListCurrPageNum = pageNum
          this.myFolderListTotalPageNum = resultData.data.totalPageNum;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },


    //选中某标记文件
    chooseMyFolderItem(item){
      this.currMyFolderId = item.fileId;
      this.currShowData = 'folder';
      this.folderDataInit = false;
      this.chooseFolderDataList = [];    //选中的数据
      this.deepFirstTraversalList = [];    //深度遍历的数据

      setTimeout(()=>{
        this.initMapbox();
        this.getFolderData()
      },200)
    },

    //解析标记文件数据
    getFolderData(){
      this.$axios.get('/authorApi/z-geo-file/openFile',{
        params:{
          'fileId':this.currMyFolderId
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){

          //数据进行树状处理
          let deleteAutonomousRegionDataList = [];
          this.$utils.markerFolderDeleteAutonomousRegion(resultData.data.content,deleteAutonomousRegionDataList)
          this.folderDataList = [
            {
              id: -1,
              geoJson:{},
              name:"对象名称",
              type:"root",
              children: deleteAutonomousRegionDataList,
            },
          ]

          this.folderDataInit = true;

          //调整树状列表缩进
          if(resultData.data.content.length > 0){
            setTimeout(()=>{
              this.$utils.markerFolderChangeTreeviewLevel("addSceneMaterialFolderDataTree");
              this.$utils.markerFolderChangeTreeviewHeader("addSceneMaterialFolderDataTree");
            })
          }
          else{
            setTimeout(()=>{
              document.querySelector("#addSceneMaterialFolderDataTree").querySelector(".v-treeview-node__root").querySelector(".v-treeview-node__level").style.display = "none";
            })
          }

          //对象默认全选
          setTimeout(()=>{
            document.getElementById("addSceneMaterialFolderDataTree").querySelector(".v-treeview-node__root").querySelector(".v-treeview-node__checkbox").click()
          },10)


          //加载数据的地图标记
          if(resultData.data.content.length > 0){
            let temp = setInterval(()=>{
              if(this.addSceneMaterialMapInitFinish && this.addSceneMaterialMap.getLayer("layer")!==undefined){
                clearInterval(temp);
                //在球上加载标记数据
                this.createMaterialMapLayer();
                this.initMaterialMapLayer(resultData.data.content);
                //飞到深度遍历的第一个点
                this.deepFirstTraversalList = [];
                this.deepFirstTraversal(this.folderDataList[0])

                if(this.deepFirstTraversalList.length > 0){
                  const bbox = turf.bbox(this.deepFirstTraversalList[0].geoJson.geo)
                  this.addSceneMaterialMap.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
                    linear: false,
                    animate: true,
                    // padding: {top: 120, bottom:130, left: 190, right: 500},
                  })
                }

              }
            },100)
          }


        }
        else{
          console.log(resultData.status + resultData.message);
        }
      })
      .catch(()=>{

      })

    },

    //点击标记名称
    clickTreeItemName(item){
      if(item.type !== 'root' && item.type !== "folder"){
        const bbox = turf.bbox(item.geoJson.geo)
        this.addSceneMaterialMap.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
          linear: false,
          animate: true,
          // padding: {top: 120, bottom:130, left: 190, right: 500},
        })
      }
    },

    //初始化mapbox
    initMapbox() {
      mapboxgl.accessToken = this.$utils.mapboxToken;
      this.addSceneMaterialMap = new mapboxgl.Map({
        container: 'addSceneMaterialMap',
        zoom: 3,
        center:[90.94487491007658, 39.86471240059555],
        style: this.$utils.mapboxStyle,
        maxZoom: 17,
        minZoom: 1,
        preserveDrawingBuffer:true,
        localIdeographFontFamily: '',
        projection: {name:'globe'},
        transformRequest: (url) => {
          if (url.indexOf('https://api.mapbox.com') > -1) { //resourceType != 'Tile' &&
            return {
              url: url.replace('https://api.mapbox.com','https://earth.jl1.cn/mapbox'),
            };
          }
        },
      });
      this.addSceneMaterialMap.on('load', ()=>{
        this.addSceneMaterialMap.setFog({
          "horizon-blend": 0.1,
          "space-color": 'rgba(0, 0, 0, 1)',
          "star-intensity": 0.15
        })
        this.addSceneMaterialMap.addSource('mapbox-dem', {
          type: 'raster-dem',
          url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
          tileSize: 512,
          maxZoom: 14,
        });
        this.addSceneMaterialMap.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1 });

        //图层列表
        this.addSceneMaterialMap.addSource('world1m2021', {
          type: 'raster',
          tiles: [
            this.$utils.world1m2021
          ],
          tileSize: 256,
          scheme: 'tms'
        });
        this.addSceneMaterialMap.addLayer({
          id: 'layer',
          type: 'raster',
          source: 'world1m2021'
        });
      });

      this.loadIconImage();
      this.addSceneMaterialMapInitFinish = true;

    },
    //加载地图图片
    loadIconImage(){
      const _this=this;
      //第一个图标
      this.addSceneMaterialMap.loadImage(
          marker_one_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_one_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_one_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_one_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_one_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_one_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_one_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_one_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_one_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_one_cyan1',image)
          }
      )
      //第二个图标
      this.addSceneMaterialMap.loadImage(
          marker_two_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_two_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_two_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_two_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_two_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_two_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_two_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_two_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_two_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_two_cyan1',image)
          }
      )
      //第三个个图标
      this.addSceneMaterialMap.loadImage(
          marker_three_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_three_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_three_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_three_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_three_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_three_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_three_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_three_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_three_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_three_cyan1',image)
          }
      )
      //第四个图标
      this.addSceneMaterialMap.loadImage(
          marker_four_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_four_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_four_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_four_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_four_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_four_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_four_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_four_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_four_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_four_cyan1',image)
          }
      )
      //第五个图标
      this.addSceneMaterialMap.loadImage(
          marker_five_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_five_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_five_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_five_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_five_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_five_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_five_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_five_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_five_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_five_cyan1',image)
          }
      )
      //第六个图标
      this.addSceneMaterialMap.loadImage(
          marker_six_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_six_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_six_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_six_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_six_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_six_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_six_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_six_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_six_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_six_cyan1',image)
          }
      )
      //第7个图标
      this.addSceneMaterialMap.loadImage(
          marker_seven_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_seven_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_seven_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_seven_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_seven_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_seven_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_seven_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_seven_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_seven_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_seven_cyan1',image)
          }
      )
      //第8个图标
      this.addSceneMaterialMap.loadImage(
          marker_eight_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_eight_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_eight_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_eight_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_eight_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_eight_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_eight_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_eight_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_eight_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_eight_cyan1',image)
          }
      )
      //第9个图标
      this.addSceneMaterialMap.loadImage(
          marker_nine_red1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_nine_red1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_nine_blue1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_nine_blue1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_nine_yellow1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_nine_yellow1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_nine_green1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_nine_green1',image)
          }
      )
      this.addSceneMaterialMap.loadImage(
          marker_nine_cyan1,
          function (error,image) {
            if(error) throw error
            _this.addSceneMaterialMap.addImage('marker_nine_cyan1',image)
          }
      )
    },

    //创建地图标记图层
    createMaterialMapLayer(){
      this.mapLayerData = {
        //点集合
        pointList:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线集合
        lineList:{
          line:{
            "type": "FeatureCollection",
            "features": []
          },
          lineName:{
            'type': 'FeatureCollection',
            'features': []
          }
        },
        //多边形集合
        polygonList:{
          polygon:{
            "type": "FeatureCollection",
            "features": []
          },
          polygonName:{
            'type': 'FeatureCollection',
            'features': []
          }
        },


      }
      //多边形边框+填充
      this.addSceneMaterialMap.addSource('materialMapPolygon',{
        type:"geojson",
        data:this.mapLayerData.polygonList.polygon
      })
      this.addSceneMaterialMap.addLayer({
        id: 'materialMapPolygonLine',
        type: 'line',
        source: 'materialMapPolygon',
        paint: {
          'line-color': ["get", "lineColor"],
          'line-width': ["get", "width"],
        }
      })
      this.addSceneMaterialMap.addLayer({
        id: 'materialMapPolygon',
        type: 'fill',
        source: 'materialMapPolygon',
        paint: {
          'fill-color': ["get", "color"],
          'fill-opacity': 0.5,
        }
      })
      //多边形名
      this.addSceneMaterialMap.addSource('materialMapPolygonName',{
        type:"geojson",
        data:this.mapLayerData.polygonList.polygonName
      })
      this.addSceneMaterialMap.addLayer({
        id:'materialMapPolygonName',
        type:'symbol',
        source: 'materialMapPolygonName',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "center",
          // "visibility":'visible'
        },
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })

      //线
      this.addSceneMaterialMap.addSource('materialMapLine', {
        type: 'geojson',
        data: this.mapLayerData.lineList.line
      });
      this.addSceneMaterialMap.addLayer({
        id: 'materialMapLine',
        type: 'line',
        source: 'materialMapLine',
        paint: {
          'line-color': ["get", "color"],
          'line-width': ["get", "width"],
          'line-opacity': 1
        }
      });
      //线名
      this.addSceneMaterialMap.addSource('materialMapLineName',{
        type:"geojson",
        data:this.mapLayerData.lineList.lineName
      })
      this.addSceneMaterialMap.addLayer({
        id:'materialMapLineName',
        type:'symbol',
        source: 'materialMapLineName',
        layout:{
          "text-field": ["get", "name"],
          "text-font":this.$store.state.font,
          "text-size":16,
          "text-anchor": "top",
          "text-offset": [-1.3,1],
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
        },
        paint:{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
        }
      })

      //点
      this.addSceneMaterialMap.addSource('materialMapPoint',{
        type:"geojson",
        data:this.mapLayerData.pointList
      })
      this.addSceneMaterialMap.addLayer({
        "id": "materialMapPoint",
        "type": "symbol",
        "source": "materialMapPoint",
        "layout":{
          "icon-size":['get', 'size'],
          "icon-anchor":"bottom",
          "icon-image":[
            'match',
            ["concat", ['get', 'code'],['get', 'color']],
            '&#xe6b6;#FF0000','marker_one_red1',
            '&#xe6b6;#FFC800','marker_one_yellow1',
            '&#xe6b6;#2A82E4','marker_one_blue1',
            '&#xe6b6;#00FF00','marker_one_green1',
            '&#xe6b6;#00FFFF','marker_one_cyan1',

            '&#xe657;#FF0000','marker_two_red1',
            '&#xe657;#FFC800','marker_two_yellow1',
            '&#xe657;#2A82E4','marker_two_blue1',
            '&#xe657;#00FF00','marker_two_green1',
            '&#xe657;#00FFFF','marker_two_cyan1',

            '&#xe653;#FF0000','marker_three_red1',
            '&#xe653;#FFC800','marker_three_yellow1',
            '&#xe653;#2A82E4','marker_three_blue1',
            '&#xe653;#00FF00','marker_three_green1',
            '&#xe653;#00FFFF','marker_three_cyan1',

            '&#xe65a;#FF0000','marker_four_red1',
            '&#xe65a;#FFC800','marker_four_yellow1',
            '&#xe65a;#2A82E4','marker_four_blue1',
            '&#xe65a;#00FF00','marker_four_green1',
            '&#xe65a;#00FFFF','marker_four_cyan1',

            '&#xe63c;#FF0000','marker_five_red1',
            '&#xe63c;#FFC800','marker_five_yellow1',
            '&#xe63c;#2A82E4','marker_five_blue1',
            '&#xe63c;#00FF00','marker_five_green1',
            '&#xe63c;#00FFFF','marker_five_cyan1',

            '&#xe651;#FF0000','marker_six_red1',
            '&#xe651;#FFC800','marker_six_yellow1',
            '&#xe651;#2A82E4','marker_six_blue1',
            '&#xe651;#00FF00','marker_six_green1',
            '&#xe651;#00FFFF','marker_six_cyan1',

            '&#xe664;#FF0000','marker_seven_red1',
            '&#xe664;#FFC800','marker_seven_yellow1',
            '&#xe664;#2A82E4','marker_seven_blue1',
            '&#xe664;#00FF00','marker_seven_green1',
            '&#xe664;#00FFFF','marker_seven_cyan1',

            '&#xe654;#FF0000','marker_eight_red1',
            '&#xe654;#FFC800','marker_eight_yellow1',
            '&#xe654;#2A82E4','marker_eight_blue1',
            '&#xe654;#00FF00','marker_eight_green1',
            '&#xe654;#00FFFF','marker_eight_cyan1',

            '&#xe656;#FF0000','marker_nine_red1',
            '&#xe656;#FFC800','marker_nine_yellow1',
            '&#xe656;#2A82E4','marker_nine_blue1',
            '&#xe656;#00FF00','marker_nine_green1',
            '&#xe656;#00FFFF','marker_nine_cyan1',

            'marker_one_blue1'
          ],
          "text-font":this.$store.state.font,
          "text-field": ["get", "name"],
          "text-size":16,
          "text-anchor": "bottom",
          // "text-offset": [0, -2.3],
          "text-offset":[ 'interpolate',
            ["linear"],
            ['get', 'size'],
            0.5,
            ["literal", [0, -2.5]],
            0.7,
            ["literal", [0, -5]],
            0.9,
            ["literal", [0, -5]],
            1.1,
            ["literal", [0, -7.4]],
          ],
          "icon-allow-overlap":true,
          "text-allow-overlap":true,
          "visibility":'visible',
        },
        "filter":['==','visible','visible'],
        "paint":{
          "text-color": "#ffffff",
          "text-halo-color":'rgba(0, 0, 0, 1)',
          "text-halo-blur":3,
          "text-halo-width": 1,
          "icon-opacity": 1,
        }
      },)


    },
    //初始化文件的地图标记
    initMaterialMapLayer(val){
      for(let i =0;i<val.length;i++){
        if(val[i].type !=='folder'){
          this.addMapLayer(val[i])
        }
        this.initMaterialMapLayer(val[i].children)
      }
    },
    addMapLayer(item){
      switch(item.type){
        case "point":{
          this.mapLayerData.pointList.features.push(item.geoJson.geo)
          this.addSceneMaterialMap.getSource('materialMapPoint').setData(this.mapLayerData.pointList)
          break;
        }
        case "lineString": case "roadString":{
          console.log(item.name)
          this.mapLayerData.lineList.line.features.push(item.geoJson.geo)
          this.addSceneMaterialMap.getSource('materialMapLine').setData(this.mapLayerData.lineList.line)
          this.mapLayerData.lineList.lineName.features.push({
            type: 'Feature',
            id: item.geoJson.geo.id,
            geometry: {
              type:"Point",
              coordinates:item.geoJson.geo.geometry.coordinates[0]
            },
            properties: {
              "name": item.geoJson.geo.properties.name
            },
          })
          this.addSceneMaterialMap.getSource('materialMapLineName').setData(this.mapLayerData.lineList.lineName)

          break;
        }
        case "circle": case "rectangle": case "polygon":{
          this.mapLayerData.polygonList.polygon.features.push(item.geoJson.geo)
          this.addSceneMaterialMap.getSource('materialMapPolygon').setData(this.mapLayerData.polygonList.polygon)
          this.mapLayerData.polygonList.polygonName.features.push({
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: item.geoJson.geo.properties.center
            },
            id: item.geoJson.geo.id,
            properties: {
              "name":item.geoJson.geo.properties.name
            },
          })
          this.addSceneMaterialMap.getSource('materialMapPolygonName').setData(this.mapLayerData.polygonList.polygonName)

          break;
        }

      }


    },

    //清空地图标记
    clearMaterialMapLayer(){
      if(this.addSceneMaterialMap !== ""){
        if(this.addSceneMaterialMap.getLayer("materialMapPolygon")){
          this.addSceneMaterialMap.removeLayer('materialMapPolygon')
          this.addSceneMaterialMap.removeLayer('materialMapPolygonLine')
          this.addSceneMaterialMap.removeSource('materialMapPolygon')
        }
        if(this.addSceneMaterialMap.getLayer("materialMapPolygonName")){
          this.addSceneMaterialMap.removeLayer('materialMapPolygonName')
          this.addSceneMaterialMap.removeSource('materialMapPolygonName')
        }
        if(this.addSceneMaterialMap.getLayer("materialMapLine")){
          this.addSceneMaterialMap.removeLayer('materialMapLine')
          this.addSceneMaterialMap.removeSource('materialMapLine')
        }
        if(this.addSceneMaterialMap.getLayer("materialMapLineName")){
          this.addSceneMaterialMap.removeLayer('materialMapLineName')
          this.addSceneMaterialMap.removeSource('materialMapLineName')
        }
        if(this.addSceneMaterialMap.getLayer("materialMapPoint")){
          this.addSceneMaterialMap.removeLayer('materialMapPoint')
          this.addSceneMaterialMap.removeSource('materialMapPoint')
        }
      }


      this.mapLayerData = {
        //点集合
        pointList:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线集合
        lineList:{
          line:{
            "type": "FeatureCollection",
            "features": []
          },
          lineName:{
            'type': 'FeatureCollection',
            'features': []
          }
        },
        //多边形集合
        polygonList:{
          polygon:{
            "type": "FeatureCollection",
            "features": []
          },
          polygonName:{
            'type': 'FeatureCollection',
            'features': []
          }
        },
      };


    },

    //深度遍历文件内容，飞到第一个点的位置
    deepFirstTraversal(root){
      if(root.type !== "root" && root.type !== "folder"){
        this.deepFirstTraversalList.push(root);
      }
      else{
        // 获取所有的子节点
        // root.childNode获取所有子节点(包括注释节点，文本节点，HTML元素节点)
        // root.children获取所有HTML元素节点
        let childNodes = root.children
        // 对每一个子节点都进行深度优先遍历
        if (childNodes.length) {
          childNodes.forEach((item) => {
            this.deepFirstTraversal(item)
          })
        }
      }
    },



    //确定导入来自文件的素材
    addMaterialFromFolderOK(){
      //计算应得到的素材总数，用于判断素材是否添加完成
      let totalMaterialListNum;
      if(this.$store.state.currChooseSceneItemIndex !== ''){
        totalMaterialListNum = this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList.length + this.chooseFolderDataList.length;
      }
      else{
        totalMaterialListNum = this.$store.state.tempMaterialInfo.materialList.length + this.chooseFolderDataList.length;
      }


      if(this.$store.state.currChooseSceneItemIndex !== ''){
        for(let i=0;i<this.chooseFolderDataList.length;i++){
          console.log(this.chooseFolderDataList[i])
          let currMaterialItem = JSON.parse(JSON.stringify(this.chooseFolderDataList[i]));
          this.$set(currMaterialItem,"showSet",{
            "timeRange":this.$store.state.scenePointEditing ? [0,this.$store.state.tempViewPointList.length] : [0,this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].viewPointList.length],
            "allShowInScenePoint":false,
            "materialShowAnimation":"无",
            "materialHideAnimation":"无",
            "defaultStyle":true,
            "showName":true,
            "showPoint":false,
            "showMarkerImage":false,
            "showTop":false,
            "totalVisible":true,
          })

          //判断该素材是否已经导入过（id会重复）
          console.log(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList)
          let idRepeat = false;
          for(let j=0;j<this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList.length;j++){
            if(this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList[j].id === currMaterialItem.id){
              idRepeat = true;
              break;
            }
          }

          if(idRepeat){
            this.$utils.getNewId((newId)=>{
              this.$set(currMaterialItem,'id',newId);
              this.$set(currMaterialItem.geoJson.geo,'id',newId);
              this.$set(currMaterialItem.geoJson.geo.properties,'id',newId);
              if(currMaterialItem.geoJson.points.length !== 0){
                for(let j=0;j<currMaterialItem.geoJson.points.length;j++){
                  this.$set(currMaterialItem.geoJson.points[j],'id',newId);
                }
              }
              this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList.push(currMaterialItem)
            })
          }
          else{
            this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList.push(currMaterialItem)
          }
        }
      }
      else{
        for(let i=0;i<this.chooseFolderDataList.length;i++){
          let currMaterialItem = JSON.parse(JSON.stringify(this.chooseFolderDataList[i]));
          this.$set(currMaterialItem,"showSet",{
            "timeRange":[0,this.$store.state.tempViewPointList.length],
            "allShowInScenePoint":false,
            "materialShowAnimation":"无",
            "materialHideAnimation":"无",
            "defaultStyle":true,
            "showName":true,
            "showPoint":false,
            "showMarkerImage":false,
            "showTop":false,
            "totalVisible":true,
          })

          //判断该素材是否已经导入过（id会重复）
          let idRepeat = false;
          for(let j=0;j<this.$store.state.tempMaterialInfo.materialList.length;j++){
            if(this.$store.state.tempMaterialInfo.materialList[j].id === currMaterialItem.id){
              idRepeat = true;
              break;
            }
          }

          if(idRepeat){
            this.$utils.getNewId((newId)=>{
              this.$set(currMaterialItem,'id',newId);
              this.$set(currMaterialItem.geoJson.geo,'id',newId);
              this.$set(currMaterialItem.geoJson.geo.properties,'id',newId);
              if(currMaterialItem.geoJson.points.length !== 0){
                for(let j=0;j<currMaterialItem.geoJson.points.length;j++){
                  this.$set(currMaterialItem.geoJson.points[j],'id',newId);
                }
              }
              this.$store.state.tempMaterialInfo.materialList.push(currMaterialItem)
            })
          }
          else{
            this.$store.state.tempMaterialInfo.materialList.push(currMaterialItem)
          }

        }
      }

      if(this.$store.state.currChooseSceneItemIndex !== ''){
        let temp = setInterval(()=> {
          if (this.$store.state.sceneList[this.$store.state.currChooseSceneItemIndex].materialInfo.materialList.length === totalMaterialListNum) {
            clearInterval(temp)
            this.$emit("addMaterialOK","");
          }
        },100)
      }
      else{
        let temp = setInterval(()=> {
          if (this.$store.state.tempMaterialInfo.materialList.length === totalMaterialListNum) {
            clearInterval(temp)
            this.$emit("addMaterialOK","");
          }
        },100)
      }
    },


    //图片素材//////////////////////////////////////////////////////////////////////////////////////////
    //获取图片素材列表
    getMyImageList(pageNum){
      this.currMyImageId = "";

      this.$axios({
        method:"get",
        url:"/authorApi/z-screen-recorder-material/getMaterials",
        params:{
          keyWord:this.myImageSearchKeyword,
          curPageNum:pageNum,
          maxResultNum:10,
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          if(pageNum === 1){
            this.myImageList = resultData.data.list;
          }
          else{
            this.myImageList = this.myImageList.concat(resultData.data.list);
          }
          this.myImageListCurrPageNum = pageNum
          this.myImageListTotalPageNum = resultData.data.totalPageNum;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });


    },

    //选择一个图片
    chooseMyImageItem(item){
      this.currShowData = 'image';
      this.currMyImageItem = "";
      this.currMyImageId = "";
      setTimeout(()=>{
        this.currMyImageItem = item;
        this.currMyImageId = item.materialId;
      },10)





    },

    //删除一项图片
    deleteImageItem(index){
      this.deleteImageIndex = index;
      this.deleteImageDialogShow = true;

    },
    //确定删除
    deleteImageDialogOK(){
      this.$axios({
        method:"post",
        url:"/authorApi/z-screen-recorder-material/deleteMaterial",
        params:{
          materialId:this.myImageList[this.deleteImageIndex].materialId
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          //要删除的是当前选中的图片
          if(this.myImageList[this.deleteImageIndex].materialId === this.currMyImageId){
            this.currShowData = 'none';
            this.currMyImageItem = "";
            this.currMyImageId = "";
          }
          this.myImageList.splice(this.deleteImageIndex,1);
          this.deleteImageDialogShow = false;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });

    },

    //将图片添加到地图素材
    addImageToMap(index){
      this.$store.state.sceneMaterialImageAddingDataList = [];
      this.$store.state.sceneMaterialImageAddingDataList.push(
          {
            thumbUrl:this.myImageList[index].thumbUrl,
            name:this.myImageList[index].fileName
          }
      )
      this.$store.state.sceneMaterialImageAdding = true;

      this.$store.state.setMaterialAreaShow = false;

      this.$store.state.snackbarShow=true
      this.$store.state.snackbarText = "放置素材至地图目标区域"
      this.$store.state.snackbarType = 'info'

      this.$emit("closeDialog","");
    },


    //上传图片
    addMaterialUploadImage(){
      let file = this.$refs.addMaterialUploadImageInput.files[0];
      this.uploadImageFun(file)
    },

    //火狐拖拽上传
    materialUploadDrop(event){
      event.preventDefault()
      const file = event.dataTransfer.files[0];
      this.uploadImageFun(file)
    },

    //上传图片方法
    uploadImageFun(file){
      if(file.type !== "image/png" && file.type !== "image/jpeg" && file.type !== "image/jpg"){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件必须为以下格式：jpg、jpeg、png"
        this.$store.state.snackbarType = 'error'

        this.$refs.addMaterialUploadImageInput.value = '';
      }
      else if(file.size > 1024 * 1024 * 5){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件大小不能超过5M"
        this.$store.state.snackbarType = 'error'

        this.$refs.addMaterialUploadImageInput.value = '';
      }
      else{
        //合法
        let paramData = new FormData();
        paramData.append('multipartFile',file);
        this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
            .then((resultData)=>{
              resultData = resultData.data;
              console.log(resultData)
              if(resultData.status === 200){
                let paramAddAddMaterial = new FormData();
                paramAddAddMaterial.append('fileName',file.name);
                paramAddAddMaterial.append('fileUrl',resultData.data.picture);
                paramAddAddMaterial.append('thumbUrl',resultData.data.picture);
                paramAddAddMaterial.append('fileSize',file.size);
                this.$axios.post('/authorApi/z-screen-recorder-material/addMaterial',paramAddAddMaterial)
                    .then((resultDataAddMaterial)=>{
                      resultDataAddMaterial = resultDataAddMaterial.data;
                      console.log(resultDataAddMaterial)
                      if(resultDataAddMaterial.status === 200){
                        this.myImageList.unshift({
                          "fileName": file.name,
                          "fileSize": file.size,
                          "fileUrl": resultData.data.picture,
                          "materialId": resultDataAddMaterial.data,
                          "thumbUrl": resultData.data.picture,
                        })

                        this.$store.state.snackbarShow=true
                        this.$store.state.snackbarText = "素材上传成功"
                        this.$store.state.snackbarType = 'success'

                        //图片列表区域滚动到最上方
                        this.$refs.myImageListArea.scrollTop = 0;

                        this.$refs.addMaterialUploadImageInput.value = '';
                      }else{
                        this.$refs.addMaterialUploadImageInput.value = '';
                      }
                    })
                    .catch(()=>{
                      this.$refs.addMaterialUploadImageInput.value = '';
                    })
              }else{
                this.$refs.addMaterialUploadImageInput.value = '';
              }
            })
            .catch(()=>{
              this.$refs.addMaterialUploadImageInput.value = '';
            })
      }
    },




    ////////////////////////////////////////////////////////////////////////////////////////////


  },

  mounted(){


  },
  // destroyed() {
  //   console.log(this.$refs.myFolderListArea)
  //   console.log(this.$refs.myImageListArea)
  //   this.$refs.myFolderListArea.removeEventListener("scroll",this.myFolderListAreaScrollFun)
  //   this.$refs.myImageListArea.removeEventListener("scroll",this.myImageListAreaScrollFun)
  // }



}
</script>

<style scoped>
.dataAreaTab{
  position:relative;
  width:75px;
  height:32px;
  margin-top:3px;
}
.dataAreaTab_text{
  line-height:25px;
  text-align:center;
  font-size:18px;
  cursor:pointer;
}
.dataAreaTab_line{
  position:absolute;
  bottom:0;
  left:21px;
  width:32px;
  height:5px;
  background:#20518A;
  border-radius:5px;
  margin-top:2px;
}
.dataAreaType{
  width:100%;
  height:84px;
  border-radius:5px;
  border:1px solid #E5E5E5;
  margin-bottom:15px;
  padding:0 21px 0 22px;
  display:flex;
  align-items:center;
}
.dataAreaType:hover{
  border-color:#2A82E4;
}
.dataAreaType_btn{
  font-size:22px;
  color:#2A82E4;
  cursor:pointer;
  display:none;
}
.dataAreaType:hover .dataAreaType_btn{
  display:block;
}


.markerFolderDataTree{
  position:relative;
  width:100%;
  flex:1;
  padding:0 0 0 10px;
  margin-top:20px;
  overflow:auto;
}


.myImageItemBtn{
  font-size:20px;
  color:#a6a6a6;
}
.myImageItemBtn:hover{
  color:#2A82E4;
}


</style>

<style>
#addSceneMaterialFolderDataTree .v-treeview-node__checkbox{
  margin-right:0;
  font-size: 18px;
}
#addSceneMaterialFolderDataTree .v-treeview-node__content{
  margin-left:0;
}
#addSceneMaterialFolderDataTree .v-treeview-node__root{
  position:sticky!important;
  top:0;
  width:346px!important;
}
#addSceneMaterialFolderDataTree .v-treeview-node__children{
  padding-top:0!important;
}

</style>

